<template>
  <div
    class="upsell-feature-grid grid w-full gap-4 md:grid-cols-2"
    data-testid="upsell-feature-grid"
  >
    <OwnCard
      v-for="feature in features"
      :key="feature.title"
      class="upsell-feature-grid__card items-start gap-4 p-4"
      radius="16px"
      :data-testid="`upsell-feature-card-${toTestId(feature.title)}`"
    >
      <span class="upsell-feature-grid__icon" aria-hidden="true">
        <component :is="feature.icon ?? SparklesSoft" :size="20" />
      </span>
      <div class="flex flex-col gap-1">
        <OwnType :text="feature.title" variant="title-small" />
        <OwnType :text="feature.description" variant="paragraph-small" />
      </div>
    </OwnCard>
  </div>
</template>

<script lang="ts" setup>
import { SparklesSoft } from '@owner/icons-vue/SparklesSoft'

import { OwnCard } from '@/ui/OwnCard'
import { OwnType } from '@/ui/OwnType'

import type { UpsellFeature } from '../types'
import { toTestId } from '../utils'

defineProps<{
  features: UpsellFeature[]
}>()
</script>

<style lang="scss" scoped>
.upsell-feature-grid {
  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 12px;
    // Warm tile behind the sparkle icon, from the tier-upgrades design — not a
    // Hermes palette token.
    background-color: #f8f3ee;
  }
}
</style>
